import { Component } from '@angular/core';

@Component({
  selector: 'app-item-not-created',
  templateUrl: './item-not-created.component.html',
  styleUrls: ['./item-not-created.component.scss']
})
export class ItemNotCreatedComponent {

  constructor() {
  }

  public textByDefault(): string {
    const routUrl: string = location.href;
    let text: string = '';

    if (routUrl) {
      const path = routUrl.split('/')
      if (path[5] == 'allied') {
        text = "ORGANIZATION.facilitatorNotCreated"
      } if (path[5] == "group") {
        text = "ORGANIZATION.itemNotCreatedYet"
      };
    }
    return text;
  }

}
